<template>
  <el-carousel class="banner-wrapper"
               @change="carouselChange"
               :height="clientWidth? 'calc(100vh - 70px)' : 'calc(100vh - 70px)'"
               arrow="never"
               :interval="10000"
               >
<!--   :autoplay="false" -->
    <el-carousel-item v-for="(item, index) in imgList" :key="index">
      <div class="banner-text" :ref="'warp' + index">
        <div class="banner_p">
          <h2>{{item.title}}</h2>
          <p class="fnt_28">{{item.content}}</p>
        </div>
      </div>
      <img class="img-bg" :src='item.img'/>
<!--      <video :src='"../../../static/video/test"+ index + ".mp4"'-->
<!--             autoplay="autoplay" muted=""-->
<!--             :loop="true"-->
<!--             :height="videoHeight - 70"-->
<!--             :width="videoWidth"-->
<!--             class="video-bg" style="display: block;"></video>-->
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import Video from '../videoTable/videoPlay'
export default {
  components: {Video},
  data () {
    return {
      imgList: [],
      clientWidth: false,
      videoHeight: 0,
      videoWidth: 0,
      show: false
    }
  },
  methods: {
    carouselChange (index) {
      this.imgList.forEach((item, imgIndex) => {
        if (index === imgIndex) {
          this.$refs['warp' + imgIndex][0].style.opacity = 1
          this.$refs['warp' + imgIndex][0].style.left = '100px'
        } else {
          this.$refs['warp' + imgIndex][0].style.opacity = 0
          this.$refs['warp' + imgIndex][0].style.left = '30%'
        }
      })
    }
  },
  mounted: function () {
    this.clientWidth = document.documentElement.clientWidth > 1200
    this.videoHeight = document.documentElement.clientHeight
    console.log('videoHeight', this.videoHeight)
    this.videoWidth = document.documentElement.clientWidth
    // this.imgList = this.$boss.page01.g00
    setTimeout(() => {
      this.$refs['warp' + 0][0].style.opacity = 1
      this.$refs['warp' + 0][0].style.left = '100px'
    }, 500)
    // console.log('this.$boss', this.$boss)
    if (this.$boss && this.$boss.page011) {
      this.imgList = this.$boss.page011.g011
    }
  }
}
</script>
<style scoped lang="less">
  .video-bg {
    position: absolute;
    /*height: 100%;*/
    left: 0px;
    top: 0;
    object-fit: cover;
  }
  @media screen and (max-width: 899px){
    .banner-wrapper {
      width: 100%;
      height: calc(100vh - 60px);
      .img-bg{
        width: 100%;
        height: auto;
      }
    }
  }
  @media screen and (min-width: 900px){
    .banner-wrapper {
      width: 100%;
      height: calc(100vh - 70px);
      .img-bg{
        width: 100%;
        height: 100%;
      }
    }
  }
  .banner-text {
    color: #fff;
    position: absolute;
    left: 50%;
    top: 45%;
    text-align: left;
    width: 100%;
    z-index: 999;
    /* bottom: 120px; */
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
    -ms-transform: translate(0,-50%);
    opacity: 0;
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
  }
  .banner_p h2, .banner_p p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .banner_p p {
    font-size: 28px;
  }
  .banner_p h2 {
    font-size: 52px;
    margin-bottom: 15px;
    line-height: 60px;
    max-height: 120px;
  }
  // ---------------------------------
  .banner-wrapper /deep/ .el-carousel__button {
    width: 120px;
    background-color: #FFFFFF
  }
  .banner-wrapper /deep/.is-active .el-carousel__button {
    width: 120px;
    background-color: #ec6700;
  }
  .banner-wrapper /deep/ .el-carousel__indicator--horizontal {
    padding: 30px 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/banner.vue